<template>
    <div class="template-configuration">
        <el-row>
      <el-col :span="5" style="padding: 0 5px">
        <el-card
          body-style="height: 850px;"
          class="box-card devices-area"
          shadow="never"
        >
          <div
            style="width: 100%; height: 100%; overflow: auto"
            class="comp-tree"
          >
            <el-tree
              :data="treeData"
              node-key="unitName"
              ref="tree"
              row-key="id"
              :props="defaultProps"
              :highlight-current="true"
              default-expand-all
              class="ut-custom-tree-list"
   @node-click="treeClick"
            >
                       <!--  -->
               <!--  -->
              <!-- :expand-on-click-node="false" 是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点 -->
              <div slot-scope="{ node ,data}">
                <!-- <i v-if="data.children" class="el-icon-folder-opened"></i>
                <i v-else class="el-icon-folder"></i> -->
                <!-- <img src="../../assets/energyApplication/文件夹.png"  style="vertical-align: bottom; width: 25px"/> -->
                <img src="../../../assets/rateTemplate/公司.png"  style="vertical-align: bottom; width: 25px"/>
                <div v-if="false">{{node}}</div>
                <span :class="['unit-name',{'active':data.no==1}]">{{ data.unitName }}</span>
                 <!-- <img src="../../../assets/rateTemplate/peizhi.png"  v-if="data.temId"/> -->
              </div>
            </el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" >
        <el-card
          body-style="height: 850px;backgroud-color:#edf2f9"
          class="box-card devices-area"
          shadow="never"
        >
        <div class="content ">
            <div class="titles">计费模板配置应用</div>
            <div class="templates">
                <div class="item item1">
                    <div class="left-title">电费模板选择：</div>
                    <div class="right">
                         <el-radio-group v-model="electricRadio">
                            <el-radio :label="1">单价模板</el-radio>
                            <el-radio :label="2">阶梯模板</el-radio>
                            <el-radio :label="3">尖峰平谷</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                   <div class="item ">
                    <div class="left-title">水费模板选择：</div>
                    <div class="right">
                         <el-radio-group v-model="waterRadio">
                            <el-radio :label="1">单价模板</el-radio>
                            <el-radio :label="2">阶梯模板</el-radio>
                            <el-radio :label="3">尖峰平谷</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                   <div class="item ">
                    <div class="left-title">气费模板选择：</div>
                    <div class="right">
                         <el-radio-group v-model="gasRadio">
                            <el-radio :label="1">单价模板</el-radio>
                            <el-radio :label="2">阶梯模板</el-radio>
                            <el-radio :label="3">尖峰平谷</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="btns">
                     <el-button type="primary"  size="small" @click="application_fn">应用</el-button>
                </div>
            </div>
        </div>
       
        </el-card>
      </el-col>
    </el-row>
    </div>
</template>

<script>
import {getRateTree} from "../../../api/rateConfiguration";
import {saveTemApplication} from "../../../api/reading";
export default {
  data() {
    return {
      electricRadio:"", //电单选框
      gasRadio:"",//气单选框
      waterRadio:"",//水单选框
      param:"",
      treeData:[], //树形结构数据
      defaultProps: {
        children: "children",
        unitName: "unitName",
      },
      searchName:"",//搜索框名称
      checked:true, // 查看全部按钮
      param:"", //默认选中
      temDate:null,//首页费率模板数据
      treeUnitNo:"", // 树形数据的no
      temId:"", //单选框选中模板id
      
    };
  },
  mounted(){
    //    this.treeData = localStorage.getItem("treeList")
    //    console.log("treeList",this.);
    this.getRateTreeFun()
  },
    methods: {
      application_fn(){
        let energyTypeBilling = []

         if(this.electricRadio != ""){
             energyTypeBilling.push({
              "billingType":this.electricRadio-1,
              "energyTypeList":"ELECTRIC"
             })
         }
          if(this.waterRadio != ""){
            energyTypeBilling.push({
              "billingType":this.waterRadio-1,
              "energyTypeList":"WATER"
             })
         }
         if(this.gasRadio != ""){
            energyTypeBilling.push({
                "billingType":this.gasRadio-1,
                "energyTypeList":"GAS"
              })
         }
         console.log(energyTypeBilling);
         var d = {
          "energyTypeBilling":energyTypeBilling,
          'unitNo':this.treeUnitNo
         }
         saveTemApplication(d).then(res => {
          console.log("绑定的结果",res);
         })
       

      },
         //表格样式
    headerStyle() {
		  return {
		    background: "#f3f8ff",
		    textAlign: "center",
		    color: "#999999",
		  	fontSize:"18px",
        fontWeight: "bold",
        borderColor:"#999999"
		  };
		},
            // 获取树形数据
    getRateTreeFun(){
      getRateTree().then(data => {
            this.treeData.push(data.data[0]) 
      })
    },
    
       //操作提醒
     operationFun(types,describe){
          this.$message({
             type: types,
             message: describe,
             duration:1500,
             offset:-150
          });
    },
      //节点点击
      treeClick(a){
        this.treeUnitNo = a.no

        // if(a.temId){
        //    let index = this.temDate.findIndex(item => item.id == a.temId)
        //    this.param = index
        // }else {
        //   this.param = ""
        // }
      },
    },
     //过滤器
  filters:{
    //能源类型 ELECTRIC(电)  WATER(水) GAS(气)
    energyType(val){
      if(val == 'ELECTRIC'){
        return "电"
      }else if(val == 'WATER'){
        return "水"
      }else {
        return "气"
      }
    },
     //单位类型
      company(val){
      if(val == 'ELECTRIC'){
        return "kw·h"
      }else if(val == 'WATER'){
        return "t"
      }else {
        return "m³"
      }
    },
    //阶梯名称
    sectionNameFun(val){
      if(val == '第1阶梯'){
        return "第一阶梯"
      }else if(val == '第2阶梯'){
        return "第二阶梯"
      }else if(val == '第3阶梯'){
        return "第三阶梯"
      }else {
        return val
      }
    },
    // 转换时间戳
    "date_format":function (value) { //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

      let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
      let strDate = Y + M + D + h + m + s;
       return strDate
    },
  }
}
</script>

<style lang="scss" scoped>
.template-configuration {
     
        .titles {
            font-size: 17px;
            color: #333;
            font-weight: bold;
        }
        .content {
            .templates {
                width: 610px;
                height: 332px;
                border: 1px solid #999999;
                margin-top: 40px;
                margin-left: 40px;
                .item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 0px 80px 60px 60px;
                    .left-title {
                        font-size: 16px;
                        
                    }
                    /deep/.el-radio__inner{
                        width: 16px;
                        height: 16px;
                    }
                    /deep/.el-radio__label {
                        font-size: 16px;
                    }
                    /deep/.el-radio-group{
                        height: 21px;
                        display: flex;
                        align-items: center;
                    }
                    .right {
                        height: 21px;

                    }
                 
                }
                .item1 {
                    margin-top: 40px;
                }
                .btns {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 80px;
                }
            }
        }
       
}

</style>

